import React from "react";
import {
  Box,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  InputBase,
} from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import {
  Close,
  Search as SearchIcon,
  Clear as ClearIcon,
} from "@mui/icons-material";
import { sortBy } from "underscore";
import { TicketList } from "../TicketList";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "24ch",
    },
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const ClearIconWrapper = styled("div")(({ theme }) => ({
  height: "100%",
  position: "absolute",
  // pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: "0px",
  top: "0px",
}));

const ProgramBadgesModal = ({
  open,
  event,
  handleClose,
  tickets,
  searchText,
  handleSearchTextChange,
  onNavigateToOrderDetails,
  setEditingTicketId,
  handleCheckInClick,
}) => {
  const { name: eventName } = event || {};

  const unProgrammedTickets = tickets.filter(({ badge }) => !Boolean(badge));
  const programmedTickets = sortBy(
    tickets.filter(({ badge }) => Boolean(badge)),
    ({ badge }) => {
      return -badge.programmedAt.seconds;
    },
  );

  return (
    <Dialog fullScreen open={open} onClose={handleClose}>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <Close />
          </IconButton>
          <Typography
            sx={{
              ml: 2,
              flex: 1,
              display: "-webkit-box",
              // overflow: "hidden",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 3,
            }}
            variant="h6"
            component="div"
          >
            {eventName}
          </Typography>

          <Search>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              value={searchText}
              placeholder="Search…"
              inputProps={{ "aria-label": "search" }}
              onChange={(e) => {
                setEditingTicketId(null);
                handleSearchTextChange(e.target.value);
              }}
              InputProps={{
                endAdornment: (
                  <IconButton
                    onClick={() => {
                      setEditingTicketId(null);
                      handleSearchTextChange("");
                    }}
                  >
                    <ClearIcon />
                  </IconButton>
                ),
              }}
            />

            <ClearIconWrapper>
              <IconButton
                onClick={() => {
                  setEditingTicketId(null);
                  handleSearchTextChange("");
                }}
              >
                <ClearIcon color="white" />
              </IconButton>
            </ClearIconWrapper>
          </Search>
        </Toolbar>
      </AppBar>
      <Box sx={{ padding: "20px" }}>
        <TicketList
          tickets={unProgrammedTickets}
          checkIsPositive={(ticket) => {
            return Boolean(ticket.badge);
          }}
          handleCheckInClick={handleCheckInClick}
          event={event}
          handleEditChange={(ticketId) => {
            setEditingTicketId(ticketId);
          }}
          negativeButtonText={"Program"}
          positiveButtonText={"Programmed"}
          onOrderIdClicked={onNavigateToOrderDetails}
          onOrderIdFilterClick={(orderId) => {
            handleSearchTextChange(orderId);
          }}
        />
        <Box height={"20px"}></Box>
        <TicketList
          tickets={programmedTickets}
          checkIsPositive={(ticket) => {
            return Boolean(ticket.badge);
          }}
          handleCheckInClick={handleCheckInClick}
          event={event}
          handleEditChange={(ticketId) => {
            setEditingTicketId(ticketId);
          }}
          negativeButtonText={"Program"}
          positiveButtonText={"Programmed"}
          onOrderIdClicked={onNavigateToOrderDetails}
          onOrderIdFilterClick={(orderId) => {
            handleSearchTextChange(orderId);
          }}
        />
      </Box>
    </Dialog>
  );
};

export default ProgramBadgesModal;
